import React from 'react';
import PropTypes from 'prop-types';
import { Button, Badge } from '@dev-go4ellis/go4-design-system';
import './Hero.scss';

const BULLETS = [
  { title: 'You set the rate', body: 'Go4 never sets or marks up pay.' },
  { title: 'Free to post', body: 'Billed only on hours worked.' },
  { title: 'No contracts', body: 'No subscriptions or minimums.' },
];

const Hero = ({ onPrimaryCTA, onSecondaryCTA }) => (
  <section className="pl-hero">
    <div className="pl-hero__inner">
      <div className="pl-hero__badge">
        <Badge variant="soft" color="info" size="sm">PRICING</Badge>
      </div>

      <h1 className="pl-hero__title">
        One flat <span className="pl-hero__accent">17.5%</span> service fee
      </h1>

      <p className="pl-hero__subtitle">
        Know what athletic trainer coverage costs before you post. You set the
        hourly rate. Go4 adds one 17.5% service fee that covers licensure
        verification, payments, insurance and documentation. No subscriptions,
        no per-seat pricing, no charge until a shift is worked.
      </p>

      <p className="pl-hero__helper">
        Run the numbers in 30 seconds — no account required.
      </p>

      <div className="pl-hero__ctas">
        <Button variant="secondary" size="lg" onClick={onSecondaryCTA}>
          Estimate your cost ↓
        </Button>
        <Button variant="primary" size="lg" onClick={onPrimaryCTA}>
          Post a job free →
        </Button>
      </div>

      <div className="pl-hero__bullets">
        {BULLETS.map((b) => (
          <div key={b.title} className="pl-hero__bullet">
            <div className="pl-hero__bullet-title">{b.title}</div>
            <div className="pl-hero__bullet-body">{b.body}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

Hero.propTypes = {
  onPrimaryCTA: PropTypes.func.isRequired,
  onSecondaryCTA: PropTypes.func.isRequired,
};

export default Hero;
